// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { formatText } from 'common/util/format-text';
import { CellRenderContext, TableRow } from './types';
export const FieldWithMatches = (_ref: {
  item?: TableRow;
  context: CellRenderContext;
  shouldFormatText?: boolean;
}) => {
  let {
    context,
    shouldFormatText
  }: {
    item?: TableRow;
    context: CellRenderContext;
    shouldFormatText?: boolean;
  } = _ref;
  return <div data-sentry-component="FieldWithMatches" data-sentry-source-file="cell-mixins.tsx">
    {context.matchParts ? context.matchParts.map(part => <span sel='.mp-table-cell-match-part'>{part}</span>) : <div sel='.mp-table-cell-label'>{shouldFormatText ? formatText(context.label) : context.label}</div>}
  </div>;
};
export const getLinkCellRenderer = function getLinkCellRenderer() {
  let attrTransform: (TableRow) => any = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => ({});
  return (row: TableRow, context: CellRenderContext) => <a attrs={Object.assign({
    href: context.label
  }, attrTransform(row))}>{context.label}</a>;
};